import { ColumnDTO, ExportConfigDTO, exportFile, FilterDTO, useApiService } from "medere-ui-framework";

export function useOperatorService() {
  const { getMethod } = useApiService();
  const baseEndpoint = "/api/secured/operator";

  function getOperatorActionsReport(offset: number, pageSize: number, params: any): Promise<any[]> {
    return getMethod<any[]>({
      basePath: baseEndpoint,
      endpoint: "/getOperatorActionsReport",
      params: {
        initialDateTime: params.initialDateTime,
        finalDateTime: params.finalDateTime,
        offset,
        pageSize
      }
    });
  }

  function exportOperatorActionsReport(params: { filterDTO: FilterDTO, multiSortMeta: any, initialDateTime: Date, finalDateTime: Date }, columns: ColumnDTO[]) {
    const exportConfigDTO: ExportConfigDTO = {
      loadConfigDTO: {
        offset: 0,
        pageSize: 0,
        sortingFieldInfoList: params.multiSortMeta,
        filters: params.filterDTO
      },
      columns
    };
    return exportFile(`${baseEndpoint}/exportOperatorActionsReport`, exportConfigDTO, { initialDateTime: params.initialDateTime, finalDateTime: params.finalDateTime });
  }

  return {
    getOperatorActionsReport,
    exportOperatorActionsReport
  };
}
